import { useDuplicateDemoMutation } from '@carboncopyco/data';
import type { IDemo } from '@carboncopyco/types';
import { ConfirmAlert } from '@carboncopyco/ui';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';

interface DuplicateDemoModalProps {
  onClose: () => void;
  show: boolean;
  organizationId: string;
  demoId: string;
  goToDuplicatedDemo?: (demo: IDemo) => void;
  folderId?: string;
}

export const DuplicateDemoModal = ({
  onClose,
  show,
  organizationId,
  demoId,
  goToDuplicatedDemo,
  folderId,
}: DuplicateDemoModalProps) => {
  const [duplicateDemo, { isLoading }] = useDuplicateDemoMutation();
  const { trackEvent } = useAnalytics();
  const [isDisabled, setIsDisabled] = useBoolean();
  const location = 'demo_info_page_duplicate_demo_modal';
  return (
    <ConfirmAlert
      show={show}
      title="Duplicate this demo?"
      containerClass="w-ds-normal-modal"
      description="A new demo will be created as a copy of this one"
      noSecondButton
      onConfirm={() => {
        setIsDisabled.setTrue();
        trackEvent(AnalyticsTrackEventName.DEMO_CLICK_DUPLICATE_APPROVE, {
          location,
        });
        duplicateDemo({
          organizationId,
          id: Number(demoId),
          ...(folderId === '0' ? {} : { folderId }),
        })
          .unwrap()
          .then((newDemo) => goToDuplicatedDemo?.(newDemo))
          .catch((err) => console.error({ err }))
          .finally(() => {
            setIsDisabled.setFalse();
            onClose();
          });
      }}
      yesLabel="Duplicate"
      onClose={() => {
        trackEvent(AnalyticsTrackEventName.DEMO_CLICK_DUPLICATE_CANCEL, {
          location,
        });
        onClose();
      }}
      loading={isLoading}
      disabled={isDisabled}
    />
  );
};
